import { css } from '@emotion/react'
import { ExternalStyles } from 'bold-ui'

export function ConsultaSeguimentoExemplosHorizontalPinDown({ style }: Readonly<{ style?: ExternalStyles }>) {
  return (
    <svg width='322' height='40' viewBox='0 0 322 40' fill='none' xmlns='http://www.w3.org/2000/svg' css={css(style)}>
      <path
        d='M167 33.9577C167 30.9638 164.838 28.4795 162 28H160C157.162 28.4795 155 30.9638 155 33.9577C155 37.2948 157.686 40 161 40C164.314 40 167 37.2948 167 33.9577Z'
        fill='currentColor'
      />
      <path d='M0 14V16H160V28H162V16H322V0H320V14H162H2V0H0V14Z' fill='currentColor' />
    </svg>
  )
}
